import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import store from '@/store'

export default class PersonnelProjectSettings extends JsonApiObject {
    showTagInterface

    public constructor(data: any, included?) {
        super(data, included)
    }

    static async get(projectId: string) {
        let res = await Vue.prototype.$vbit.get('personnel', `projectSettings/${projectId}`)

        let projectSettings = new PersonnelProjectSettings(res.data, res.included)

        store.commit('showTagInterface', projectSettings.showTagInterface)
        return projectSettings
    }
}
